const getters = {
    checkInDate: state => state.checkInDate,
    checkOutDate: state => state.checkOutDate,
    searchResults: state => state.searchResults,
    searchLocation: state => state.searchLocation,
    showMapOnMobile: state => state.showMapOnMobile,
};

export default getters;